import { generalConstants } from '../constants';
import { generalService } from '../services';
import { alertActions } from './';
import { history } from '../helpers';

export const generalActions = {
  getSetting,
  getContent,
  getSubContent,
  postContent,
  putContent,
  deleteContent,
  saveUpload,
  clearUpload,
  postUpload,
  getNotification,
  postFile,
  getFile
};

//============================= SETTING ==================================
// getSetting   ->  get data from API

function getSetting(id) {
  return dispatch => {
    dispatch(request());

    generalService
      .getSetting(id)
      .then(data => dispatch(success(data)), error => dispatch(failure(error)));
  };

  function request() {
    return { type: generalConstants.SETTING_REQUEST };
  }
  function success(data) {
    return { type: generalConstants.SETTING_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.SETTING_FAILURE, error };
  }
}

// ============================= CONTENT ==================================
// getContent   ->  get data from API
// postContent  ->  post Edited data to API
// putContent   ->  put New data to API

function getContent(id, page_id) {
  return dispatch => {
    dispatch(request());

    generalService
      .getContent(id, page_id)
      .then(data => dispatch(success(data)), error => dispatch(failure(error)));
  };

  function request() {
    return { type: generalConstants.CONTENT_REQUEST };
  }
  function success(data) {
    return { type: generalConstants.CONTENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.CONTENT_FAILURE, error };
  }
}

function getSubContent(id, page_id) {
  return dispatch => {
    dispatch(request());

    generalService
      .getContent(id, page_id)
      .then(data => dispatch(success(data)), error => dispatch(failure(error)));
  };

  function request() {
    return { type: generalConstants.SUBCONTENT_REQUEST };
  }
  function success(data) {
    return { type: generalConstants.SUBCONTENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.SUBCONTENT_FAILURE, error };
  }
}

function postContent(data, id, pid) {
  return dispatch => {
    dispatch(request(data, id));

    generalService.postContent(data, id, pid).then(
      data => {
        dispatch(success());
        dispatch(alertActions.success('Saving successful'));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(data) {
    return { type: generalConstants.POST_CONTENT_REQUEST, data };
  }
  function success(data) {
    return { type: generalConstants.POST_CONTENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.POST_CONTENT_FAILURE, error };
  }
}

function putContent(data, pid) {
  return dispatch => {
    dispatch(request(data, pid));

    generalService.putContent(data, pid).then(
      data => {
        dispatch(success(data));
        dispatch(alertActions.success('Saving successful'));
      },
      error => {

        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(data) {
    return { type: generalConstants.PUT_CONTENT_REQUEST, data };
  }
  function success(data) {
    return { type: generalConstants.PUT_CONTENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.PUT_CONTENT_FAILURE, error };
  }
}

function deleteContent(id) {
  return dispatch => {
    dispatch(request(id));

    generalService.deleteContent(id).then(
      id => {
        dispatch(success(id));
        dispatch(alertActions.success('Delete successful'));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(data) {
    return { type: generalConstants.DELETE_CONTENT_REQUEST, data };
  }
  function success(data) {
    return { type: generalConstants.DELETE_CONTENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.DELETE_CONTENT_FAILURE, error };
  }
}
//============================= NOTIFICATION ==================================
// getNotification  ->  get data from API

function getNotification() {
  return dispatch => {
    dispatch(request());

    generalService
      .getNotification()
      .then(data => dispatch(success(data)), error => dispatch(failure(error)));
  };

  function request() {
    return { type: generalConstants.NOTIFICATION_REQUEST };
  }
  function success(data) {
    return { type: generalConstants.NOTIFICATION_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.NOTIFICATION_FAILURE, error };
  }
}

//============================= UPLOADER ==================================
// postUpload   ->  post new upload data to API

function postUpload(file) {
  return dispatch => {
    dispatch(request());

    generalService
      .postUpload(file)
      .then(data => dispatch(success(data)), error => dispatch(failure(error)));
  };

  function request() {
    return { type: generalConstants.UPLOAD_REQUEST };
  }
  function success(data) {
    return { type: generalConstants.UPLOAD_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.UPLOAD_FAILURE, error };
  }
}

function saveUpload(data){
  return { type: generalConstants.UPLOAD_SAVED, data };
}

function clearUpload(data){
  return { type: generalConstants.UPLOAD_CLEARED, data };
}

function postFile(data) {
  return dispatch => {
    dispatch(request(data));

    generalService.postFile(data).then(
      data => {
        dispatch(success(data));
        dispatch(alertActions.success('Saving successful'));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(data) {
    return { type: generalConstants.POST_FILES_REQUEST, data };
  }
  function success(data) {
    return { type: generalConstants.POST_FILES_SUCCESS, data };
  }
  function failure(error) {
    return { type: generalConstants.POST_FILES_FAILURE, error };
  }
}


function getFile() {
  return dispatch => {
    dispatch(request());

    generalService
      .getFile()
      .then(dataFetch => dispatch(success(dataFetch)), error => dispatch(failure(error)));
  };

  function request() {
    return { type: generalConstants.FILES_REQUEST };
  }
  function success(dataFetch) {
    return { type: generalConstants.FILES_SUCCESS, dataFetch };
  }
  function failure(error) {
    return { type: generalConstants.FILES_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/actions/general.actions.js